import { all,call, put, takeEvery } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";

import APIRequests from '../../utility/APIRequests';




function* onPOST(action) {

  try {

    const response = yield (new APIRequests).runPost(action.routeToCall, action.param);

    if (response.code == 1) {

      yield put({ type: actionTypes.PEER_SAVE, data: response?.data });

    }

    return action.callback?.(response);
  } catch (error) {

    return action.callback?.(error.response ?? error.message);
  }
}


function* onGET(action) {
  try {
    const response = yield (new APIRequests).runGet(action.routeToCall);

    if (response.code == 1) {
      yield put({ type: actionTypes.PEER_SAVE, data: response.data });
    }

    return action.callback?.(response);
  } catch (error) {
    return action.callback?.(error.response ?? error.message);
  }
}


function* watchOnPOST() {
  yield takeEvery(actionTypes.PEER_POST, onPOST);
}


function* watchOnGET() {
  yield takeEvery(actionTypes.PEER_GET, onGET);
}



export default function* peerSagas() {
  yield all([watchOnPOST(), watchOnGET()]);
}